module.exports = __webpack_public_path__ + "static/media/document-thumbnail-CBRimg5@2x.cea4bec4.png";